import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { ActionButtonsStyle, StockOutListSettingsFormStyle, DataFillFormStyle,
  RecordsPerPageFormStyle } from './css/StockOutListSettingsFormStyle'

function DateFilterForm(props) {
  const [date, setDate] = props.date
  const { app } = props
  const dateCreatedFetchAllBtnRef = useRef(null)
  const defaultDate = {
    from: (new Date(app.getClientDateTime()).getFullYear() + '-01'),
    to: (new Date(app.getClientDateTime()).getFullYear() + '-12')
  }

  useEffect(() => { dateCreatedFetchAllBtnRef.current.focus() }, [])

  const onChangeDateCreatedCheck = (e) => {
    const fetch_all = date.date_created_fetch_all
    setDate({
      ...date,
      date_created_from: fetch_all ? defaultDate.from : '',
      date_created_to: fetch_all ? defaultDate.to : '',
      date_created_fetch_all: (!fetch_all)
    })
  }

  const onChangeDateReleasedCheck = (e) => {
    const fetch_all = date.date_released_fetch_all
    setDate({
      ...date,
      date_released_from: fetch_all ? defaultDate.from : '',
      date_released_to: fetch_all ? defaultDate.to : '',
      date_released_fetch_all: (!fetch_all)
    })
  }

  return (
    <React.Fragment>
      <div id='dates' className='form-container'>
        <h4 className='header-caption'>Filter date range</h4>
        <div style={{fontSize: '0.7em', margin: '10px 0', paddingLeft: '10px'}}>
          <p> Will only fetch the data within these ranges of date.</p>
        </div>
        <div id='date-filter-form-container'>

          {/********** DATE CREATED ***********/}
          <div className='date-filter-form'>
            <label>Date Created</label>
            <hr/>
            <div className='date-field-form-container'>
              <div
                id='date-created-fetch-all-container'
                className="checkbox-fetch-all-container">
                <input
                  ref={dateCreatedFetchAllBtnRef}
                  className='top-anchor'
                  id="date-created-checkbox-fetch-all"
                  checked={date.date_created_fetch_all}
                  onChange={onChangeDateCreatedCheck}
                  type="checkbox"
                />
                {' '}
                <button
                  type="button"
                  className='fetch-all-btn'
                  onClick={onChangeDateCreatedCheck}
                  id="date-created-fetch-all-btn">
                  Fetch all
                </button>
              </div>
              <div className='date-from'>
                <label>From</label>
                <input
                  disabled={date.date_created_fetch_all}
                  value={date.date_created_from}
                  onChange={(e) => {
                    setDate({ ...date, date_created_from: e.target.value })
                  }}
                  type='month'
                />
              </div>
              <div className='date-to'>
                <label>To</label>
                <input
                  disabled={date.date_created_fetch_all}
                  value={date.date_created_to}
                  onChange={(e) => {
                    setDate({ ...date, date_created_to: e.target.value })
                  }}
                  type='month'
                />
              </div>
            </div>
          </div>

          <br/>

          {/********** DATE RELEASED ***********/}
          <div className='date-filter-form'>
            <label>Date Released</label>
            <hr/>
            <div className='date-field-form-container'>
              <div
                id='date-released-fetch-all-container'
                className="checkbox-fetch-all-container">
                <input
                  id="date-released-checkbox-fetch-all"
                  checked={date.date_released_fetch_all}
                  onChange={onChangeDateReleasedCheck}
                  type="checkbox"
                />
                {' '}
                <button
                  type="button"
                  className='fetch-all-btn'
                  onClick={onChangeDateReleasedCheck}
                  id="date-released-fetch-all-btn">
                  Fetch all
                </button>
              </div>
              <div className='date-from'>
                <label>From</label>
                <input
                  disabled={date.date_released_fetch_all}
                  value={date.date_released_from}
                  onChange={(e) => {
                    setDate({ ...date, date_released_from: e.target.value })
                  }}
                  type='month'
                />
              </div>
              <div className='date-to'>
                <label>To</label>
                <input
                  disabled={date.date_released_fetch_all}
                  value={date.date_released_to}
                  onChange={(e) => {
                    setDate({ ...date, date_released_to: e.target.value })
                  }}
                  type='month'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DataFillFormStyle />
    </React.Fragment>
  )
}

function RecordsPerPageForm(props) {
  const [footer, setFooter] = props.footer

  const onChange = (e) => {
    // if (parseInt(e.target.value) > 0) setFooter({ record_per_page: parseInt(e.target.value) })
    // else setFooter({ record_per_page: e.target.value })
    setFooter({ record_per_page: (e.target.value) ? parseInt(e.target.value) : '' })
  }

  return (
    <React.Fragment>
      <div id='rpp' className='form-container'>
        <h4 className='header-caption'>Records/Page</h4>
        <div id='rpp-form'>
          <label>Records/Page</label>
          <input
            type='number'
            min='1'
            value={footer.record_per_page || ''}
            onChange={onChange}
          />
        </div>
      </div>
      <RecordsPerPageFormStyle />
    </React.Fragment>
  )
}

function ActionButtons(props) {
  const saveStockOutSettings = props.saveStockOutSettings

  return (
    <React.Fragment>
      <div id='buttons' className='form-container'>
        <div id='action-button-container'>
          <button
            onClick={(e) => {
                saveStockOutSettings()
                ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
              }}
            className='pospro-action-btn'>
            Apply
          </button>
          <button
            onClick={(e) => {
                ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
              }}
            className='pospro-action-btn bottom-anchor'>
            Close
          </button>
        </div>
      </div>
      <ActionButtonsStyle />
    </React.Fragment>
  )
}

function useStockOutListSettingsForm(props) {
  const { stockOutListController } = props
  const [stockOutSettings, setStockOutSettings] = stockOutListController.stockOutSettings
  const [date, setDate] = useState({ ...stockOutSettings.date })
  const [footer, setFooter] = useState({ ...stockOutSettings.footer })

  const obj = {
    stockOutSettings: [stockOutSettings, setStockOutSettings],
    date: [date, setDate],
    footer: [footer, setFooter],
    saveStockOutSettings: () => stockOutListController.updateSOSettings(date, footer)
  }

  return (obj)
}

function StockOutListSettingsForm(props) {
  const stockOutListSettingsForm = useStockOutListSettingsForm(props)
  return (
    <React.Fragment>
      <div id='main-container'>
        <div className='content-wrapper'>
          <DateFilterForm app={props.app} date={stockOutListSettingsForm.date} />
          <RecordsPerPageForm footer={stockOutListSettingsForm.footer} />
        </div>
        <ActionButtons saveStockOutSettings={stockOutListSettingsForm.saveStockOutSettings} />
      </div>
      <StockOutListSettingsFormStyle />
    </React.Fragment>
  )
}

export default React.memo(StockOutListSettingsForm)